<div class="container">
    <div class="row mt-4">
        <div class="col">
            <h2>Payment failed</h2>
            <p><button routerLink="/create-store">Create a new store</button></p>
        </div>
    </div>
</div>
